import { useState, useCallback } from 'react';
import { message } from 'antd';
import { ALLOWED_FILE_TYPES, ALLOWED_FILE_EXTENSIONS } from '../constants/fileTypes';

export const useDocumentUpload = (uploadDocument) => {
  const [file, setFile] = useState(null);
  const [uploadFileName, setUploadFileName] = useState('');
  const [isFileUploaded, setIsFileUploaded] = useState(false);
  const [isUploadModalVisible, setIsUploadModalVisible] = useState(false);
  const [uploadCompany, setUploadCompany] = useState('');
  const [uploadType, setUploadType] = useState('');

  const handleFileChange = useCallback((info) => {
    const fileList = info.fileList;
    if (fileList.length > 0) {
      const file = fileList[0].originFileObj;

      if (file.size === 0) {
        message.error('Folders cannot be uploaded. Please select a document.');
        setFile(null);
        setIsFileUploaded(false);
        return;
      }

      const fileExtension = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
      if (!ALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
        message.error('Invalid file type. Please upload a supported document type (PDF, Word, Excel, PowerPoint, or CSV).');
        setFile(null);
        setIsFileUploaded(false);
        return;
      }

      if (!ALLOWED_FILE_TYPES.includes(file.type)) {
        message.error('Invalid file type. Please upload a supported document type (PDF, Word, Excel, PowerPoint, or CSV).');
        setFile(null);
        setIsFileUploaded(false);
        return;
      }

      setFile(file);
      setIsFileUploaded(true);
    } else {
      setFile(null);
      setIsFileUploaded(false);
    }
  }, []);

  const showUploadModal = useCallback(() => {
    setIsUploadModalVisible(true);
  }, []);

  const resetUploadModalStates = useCallback(() => {
    setFile(null);
    setUploadFileName('');
    setUploadCompany('');
    setUploadType('');
    setIsFileUploaded(false);
  }, []);

  const handleUploadModalCancel = useCallback(() => {
    setIsUploadModalVisible(false);
    resetUploadModalStates();
  }, [resetUploadModalStates]);

  const handleUploadModalOk = useCallback(async () => {
    if (!isFileUploaded || !file || !uploadCompany || !uploadType) {
      message.error('Please fill out all required fields and select a file.');
      return;
    }

    const result = await uploadDocument(file, uploadFileName, uploadCompany, uploadType);
    if (result.success) {
      setIsUploadModalVisible(false);
      resetUploadModalStates();
    }
  }, [file, uploadFileName, uploadCompany, uploadType, isFileUploaded, uploadDocument, resetUploadModalStates]);

  return {
    file,
    uploadFileName,
    setUploadFileName,
    isFileUploaded,
    isUploadModalVisible,
    uploadCompany,
    setUploadCompany,
    uploadType,
    setUploadType,
    handleFileChange,
    showUploadModal,
    handleUploadModalCancel,
    handleUploadModalOk,
    resetUploadModalStates,
  };
};